"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormController = void 0;
const jquery_1 = __importDefault(require("jquery"));
const utils_1 = require("../utils");
const FormState_1 = require("./FormState");
const ValidationService_1 = require("../services/ValidationService");
const EncryptionService_1 = require("../services/EncryptionService");
const EventManager_1 = require("../managers/EventManager");
const ModalManager_1 = require("../managers/ModalManager");
/**
 * Controlador principal del formulario
 */
class FormController {
    constructor() {
        this.dataFields = {};
        this.formState = new FormState_1.FormState();
        this.modalManager = new ModalManager_1.ModalManager();
        this.validationService = new ValidationService_1.ValidationService(this.formState);
        this.encryptionService = new EncryptionService_1.EncryptionService();
        this.eventManager = new EventManager_1.EventManager(this.validationService, this.handleDocumentTypeChange.bind(this));
        this.initialize();
    }
    initialize() {
        (0, utils_1.initAutocomplete)(this);
        (0, utils_1.goToStep)(1);
        this.validationService.setupFormValidation(this.handleValidationSuccess.bind(this));
        this.eventManager.setupEvents();
    }
    handleDocumentTypeChange(documentType) {
        this.validationService.updateDocumentValidation(documentType);
    }
    handleValidationSuccess(formElement) {
        this.modalManager.showSpinner();
        setTimeout(() => {
            try {
                this.buildAddressParams();
                const formData = this.extractFormData(formElement);
                this.encryptionService.encryptAndRedirect(formData);
                this.modalManager.hideSpinner();
            }
            catch (error) {
                console.error('Error processing form:', error);
                this.modalManager.hideSpinner();
            }
        }, 5000);
    }
    buildAddressParams() {
        var _a, _b, _c, _d, _e;
        const place = this.formState.addressPlace;
        if (!place || !place.address_components) {
            console.error('No se ha seleccionado una dirección válida de Google Maps.');
            throw new Error('Dirección inválida: debe seleccionar una sugerencia de Google Maps');
        }
        this.dataFields.AddressStreet = (0, utils_1.findCodeAddress)(place.address_components, 'route') || (0, utils_1.findCodeAddress)(place.address_components, 'town_square') || undefined;
        this.dataFields.AddressNumber = (_a = (0, utils_1.findCodeAddress)(place.address_components, 'street_number')) !== null && _a !== void 0 ? _a : undefined;
        this.dataFields.Province = (_b = (0, utils_1.findCodeAddress)(place.address_components, 'administrative_area_level_2')) !== null && _b !== void 0 ? _b : undefined;
        this.dataFields.Town = (_c = (0, utils_1.findCodeAddress)(place.address_components, 'locality')) !== null && _c !== void 0 ? _c : undefined;
        this.dataFields.PostalCode = (_d = (0, utils_1.findCodeAddress)(place.address_components, 'postal_code')) !== null && _d !== void 0 ? _d : undefined;
        this.dataFields.Country = (_e = (0, utils_1.findCodeAddress)(place.address_components, 'country')) !== null && _e !== void 0 ? _e : undefined;
    }
    extractFormData(formElement) {
        const $form = (0, jquery_1.default)(formElement);
        return {
            name: $form.find('input[name=Name]').val(),
            contactName: $form.find('input[name=contactName]').val(),
            contactLastName: $form.find('input[name=contactLastName]').val(),
            documentType: $form.find('select[name=documentType]').val(),
            documentNumber: $form.find('input[name=documentNumber]').val(),
            phoneNumber: $form.find('input[name=PhoneNumber]').val(),
            address: this.dataFields.AddressStreet || $form.find('input[name=Address]').val(),
            addressNumber: this.dataFields.AddressNumber,
            town: this.dataFields.Town,
            postalCode: this.dataFields.PostalCode,
            province: this.dataFields.Province,
            email: $form.find('input[name=Email]').val(),
            origen: 'bankinter',
            canal: 'SINGULAR_BANKINTER'
        };
    }
    updateAddressState(selected, place) {
        this.formState.setAddress(selected, place);
    }
}
exports.FormController = FormController;
